var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1221589LogoMediaSocialXingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Xing"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.933,21.213H17.47l4.41,7.793L16,38.72h7.462l5.879-9.713L24.933,21.213z M40.084,15l-11.76,20.671    L35.901,49h7.917L36.24,35.671L48,15H40.084L40.084,15z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1221589LogoMediaSocialXingIcon);
export default __webpack_public_path__ + "static/media/1221589_logo_media_social_xing_icon.ad6b7babf992198027bd6f9489a0ab51.svg";
export { ForwardRef as ReactComponent };